angular.module('language')
    .directive('inputTextTranslatable', function (Language) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                type: "@",
                required: "=",
                language: "=",
                onLanguageChanged: "&"
            },
            template: `
                <div class="input-group input-group-sm">
                    <input class="form-control input-sm" ng-if="currentLang == null" type="text" placeholder="wybierz język" disabled/>
                    <input ng-if="type === 'input'" type="text" ng-repeat="lang in langs track by lang.id" ng-show="lang.id === currentLang.id"
                        ng-model="selected.map[lang.code]" class="form-control input-sm" focus-element ng-change="onTextChanged()" ng-required="required && lang.id === defaultlang.id"/>

                    <textarea ng-if="type ==='textarea'" class="form-control input-sm" rows="16" ng-repeat="lang in langs track by lang.id" ng-show="lang.id === currentLang.id"
                                          ng-model="selected.map[lang.code]" ng-change="onTextChanged()" ng-required="required && lang.id === defaultlang.id"></textarea>
                    <span class="input-group-btn" style="vertical-align: top;">
                        <dropdown-language-flag-component language="currentLang" on-change="currentLangChanged(language)"></dropdown-language-flag-component>
                    </span>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.onLanguageChanged = scope.onLanguageChanged || angular.noop
                scope.type = scope.type || 'input';

                scope.currentLang = scope.language || null;
                scope.defaultlang = null;

                Language.getActive().then(items => {
                    scope.langs = items;
                    scope.defaultlang = items.find(item => item.defaultValue === true);
                    if(scope.currentLang === null) {
                        scope.currentLangChanged(scope.defaultlang);
                    }
                });

                scope.currentLangChanged = (language) => {
                    scope.currentLang = language
                    scope.onLanguageChanged({language: scope.currentLang});
                    ngModelCtrl.$validate();
                }

                ngModelCtrl.$render = () => {
                    // scope.selected = ngModelCtrl.$viewValue
                    scope.selected = ngModelCtrl.$viewValue || { map: {} };
                    ngModelCtrl.$validate();
                }
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);

                scope.onTextChanged = () => {
                    ngModelCtrl.$setViewValue(scope.selected);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                }

                scope.$watch('language', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        scope.currentLang = newValue;
                    }
                }, true);
            }
        };
    })
